<div class="pb-[32px]">
  @if(unsavedTemplates.length){
  <div class="item-list-container mb-[32px]">
    <div class="text-[#18191C] text-sm font-medium">The items listed below have not been saved: </div>
    <div class="mt-[12px] flex gap-[8px] flex-col">
      @for (item of unsavedTemplates; track item) {
      <div class="flex gap-[8px] items-center">
        <div class="bg-[#010B18] h-[6px] w-[6px] rounded-full"></div>
        <div class="text-[#5475C0] text-[12px] leading-normal font-bold">
          {{ item.path_name || item.template || item.form_name }}
        </div>
      </div>
      }
    </div>
  </div>
  } @if(emptyTemplate.length){
  <div class="item-list-container mb-[32px]">
    <div class="text-[#18191C] text-sm font-medium">Nothing has been added to these <span class="font-bold text-[#25508E]">institutions</span>: </div>
    <div class="mt-[12px] flex gap-[8px] flex-col">
      @for (item of emptyTemplate; track item) {
      <div class="flex gap-[8px] items-center">
        <div class="bg-[#010B18] h-[6px] w-[6px] rounded-full"></div>
        <div class="text-[#5475C0] text-[12px] leading-normal font-bold">
          {{ item.template || item.form_name }}
        </div>
      </div>
      }
    </div>
  </div>
  }
  <div class="rounded-xl h-[299px] w-full border bg-white flex items-center justify-center flex-col px-[50px] py-[32px]">
    <div class="text-[#53565B] font-semibold text-xl">Mark Data Audit for {{ discoveryCategoryConfigType?.name }} as complete?</div>

    <app-button-slide [isDiscoveryContent]="true" (isSubmitButtonActiveForSubMit)="setValue()" class="mt-[42px] mb-[22px]"></app-button-slide>

    <div class="app__mark--complete--info">
      <img src="/assets/images/mark-as-complete-info.svg" alt="mark-complete-info" />
      <div class="font-normal text-[12px] leading-normal text-[#898F9E]">
        You have the ability to add, edit or remove any type of template in the future from the vault section of this account.
      </div>
    </div>
  </div>
</div>
